<template>
  <div class="Resource-application">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search :data="tableFilterList(queryFields)" @search="dataTableSearch">
        <template v-slot:next>
          <el-button
            v-if="!isAdmin"
            icon="el-icon-plus"
            @click="$router.push('resourceApplication/form')"
          >新增</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{trigger: 'click', mode: 'cell'}"
        :editable="true"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
          <!-- 查看 -->
          <el-button
            type="text"
            icon="el-icon-view"
            style="color:#4084B7;"
            @click="showById(scope.row)"
          />
          <!-- 编辑 -->
          <el-button
            type="text"
            icon="el-icon-edit"
            style="color:#4084B7;"
            @click="edit(scope.row)"
            v-if="statusEdit(scope.row.billState)"
          ></el-button>
          <el-popover
            v-if="statusUnAudit(scope.row.billState)"
            :ref="'audit'+scope.row.id"
            placement="top"
            width="180"
          >
            <p>确定反审核该单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs['audit'+scope.row.id].doClose()">取消</el-button>
              <el-button type="primary" size="mini" @click="reject(scope.row, 5)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-circle-close" slot="reference"></el-button>
          </el-popover>
          <!-- 审批通过 -->
          <el-popover
            :ref="`audit${scope.row.id}`"
            placement="top"
            width="220"
            v-if="scope.row.billState === 2"
          >
            <p>确定退回该申请单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[`audit${scope.row.id}`].doClose()">取消</el-button>
                <el-button type="primary" size="mini" @click="reject(scope.row)">退回</el-button>
              <!-- <el-button type="primary" size="mini" @click="audit(scope.row)">确定</el-button> -->
            </div>
            <el-button type="text" size="mini" icon="el-icon-back" slot="reference"></el-button>
          </el-popover>
          <!-- 删除 -->
          <el-popover
            :ref="scope.row.id"
            placement="top"
            width="180"
            v-if="statusEdit(scope.row.billState)"
          >
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button :loading="loading" type="primary" size="mini" @click="del(scope.row.id)">确定</el-button>
            </div>
            <el-button
              type="text"
              size="mini"
              icon="el-icon-delete"
              style="color:red"
              slot="reference"
            ></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { deleteApplicationById, reviewResourceApply } from "@/api/bill/ResourceApplication";
import { tableSataus } from "@/views/bill/mixins/status";

export default {
  name: "ResourceApplication",
  mixins: [DataTableMixin, tableSataus],
  components: {
    DynamicSearch
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
  data() {
    return {
      queryFields: [
        {
          label: "项目名",
          prop: "projectName",
          query: {
            type: "input"
          },
        },
        {
          label: "人员",
          prop: "name",
          query: {
            type: "input"
          },
        }
      ],
      tableHead: [
        {
          label: "单据编号",
          prop: "code",
          query: {
            type: "input"
          },
          align: "center"
        },
        {
          label: "项目号",
          prop: "projectNumber",
          align: "center"
        },
        {
          label: "项目名",
          prop: "projectName",
          query: {
            type: "input"
          },
          align: "center"
        },
        {
          label: "人员",
          prop: "bsPerson.name",
          query: {
            type: "input"
          },
          align: "center"
        },
        {
          label: "工号",
          prop: "personCode",
          align: "center"
        },
        // {
        //   label: "技能类型",
        //   prop: "bsSkillsType.name",
        //   align: "center"
        // },
        // {
        //   label: "技能等级",
        //   prop: "bsSkillsLevel.name",
        //   align: "center"
        // },
        {
          label: "职级",
          prop: "bsPersonRank.name",
          align: "center"
        },
        {
          label: "结算单价",
          prop: "settlementPrice",
          align: "center"
        },
        {
          label: "单据状态",
          prop: "billState",
          align: "center",
          formatter: state => {
            return this.statusName(state);
          }
        }
      ],
      tableData: []
    };
  },
  methods: {
    // 表格数据接口参数设置
    dataTableBeforeInit() {
      this._url = `/resourceApply/findList`;
      const params = { pageNum: this.page, pageSize: this.offset, };
      this._params = Object.assign(params, this._query);
      return true;
    },
    // 删除
    del(id) {
      if (id) {
        this.$refs[id].doClose();
        this.loading = true;
        deleteApplicationById(id)
          .then(res => {
            if (res.code === 200) {
              this.loading = false;
              this.$notify({
                title: "删除成功",
                type: "success",
                duration: 2500
              })
              this.dataTableInit()
            }
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    // 修改
    edit(data) {
      this.$router.push({
        path: "resourceApplication/form",
        query: { id: data.id, isShow: false }
      });
    },
    // 查看
    showById(data) {
      this.$router.push({
        path: "resourceApplication/form",
        query: { id: data.id, isShow: true }
      });
    },
    reject(data, status = 4) {
      // 4 退回 5反审核状态
      reviewResourceApply({ id: data.id, billState: status }).then(res => {
        if (res.code === 200) {
          this.$notify({
            title: "操作成功",
            type: "success",
            duration: 2500
          });
          this.dataTableInit()
        }
      })
      this.$refs['audit' + data.id].doClose();
    },
    // 审批
    audit(data) {
      reviewResourceApply({ id: data.id, billState: 3 }).then(res => {
        if (res.code === 200) {
          this.$notify({
            title: "操作成功",
            type: "success",
            duration: 2500
          });
          this.dataTableInit()
        }
      })
      this.$refs[`audit${data.id}`].doClose();
    },
  }
};
</script>

<style lang="scss" scoped>
.dashboard-editor-container {
  height: 100%;
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}

@media (max-width: 1024px) {
  .chart-wrapper {
    padding: 8px;
  }
}
</style>
